import {Rating, TrialReportRating} from '../model/enums/enums'

export const cumulateNumbers = (numberArray: (Rating | TrialReportRating | undefined | null)[]): number => {
	if (!numberArray) {
		return 0
	}
	let sum = 0

	numberArray.forEach((num: number | undefined | null) => {
		if (num !== undefined && num !== null) {
			sum += num
		}
	})

	return sum
}

/** compare if day and month are the same on both dates, if so return true, else return false. */
export const compareIfMonthAndDayAreEqual = (dateA: Date, dateB: Date): boolean => {
	return dateA?.getMonth()?.toString() === dateB?.getMonth()?.toString() &&
        dateA?.getDate().toString() === dateB?.getDate()?.toString()
}